import React from 'react';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const TermsOfService = () => {
    const { content } = useContentfulContext();

    return (
        <div className="my-10">
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="relative mx-auto max-w-[37.5rem] text-center mb-10">
                    <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">{content.TERMS_OF_SERVICE_CONTENT.title}</h1>
                </div>
            </div>
            <div className="relative px-4 sm:px-6 lg:px-8">
                <div className="md:max-w-screen-sm lg:max-w-[992px] px-4 sm:px-6 lg:px-8 pb-12 md:pt-6 sm:pb-20 mx-auto">
                    <div className="grid gap-4 md:gap-8">
                        {
                            content.TERMS_OF_SERVICE_CONTENT.instruction_text.privacy_policy_text.map((item) => {
                                return <div>
                                    <h2 className="text-lg sm:text-xl font-semibold mb-2">{item.title}</h2>
                                    {item.desc.map((para) => {
                                        return <p className="mb-5">{para}</p>;
                                    })}
                                </div>
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TermsOfService;